import { Paper, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { FC } from 'react';
import { Link } from '../../../components';

interface IKPIMetricBox {
  name: string;
  metric: number;
  link: string;
  isActive: boolean;
}
export const KPIMetricBox: FC<IKPIMetricBox> = ({ isActive, link, name, metric }) => {
  const classes = useStyles();

  const renderContent = () => (
    <Paper className={classes.metricBox}>
      <Typography className={classes.metric} variant="h3">
        {metric}
      </Typography>
      <Typography variant="h6">{name}</Typography>
    </Paper>
  );

  if (isActive) {
    return <Link to={link}>{renderContent()}</Link>;
  }

  return <>{renderContent()}</>;
};

const useStyles = makeStyles((theme: Theme) => ({
  metricBox: {
    height: '150px',

    padding: theme.spacing(0.5),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    textAlign: 'center'
  },
  metric: {
    color: theme.palette.primary.main
  }
}));
